var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"alt":"","width":"1","height":"1","src":_vm.srcOrFallback},on:{"error":_vm.handlePixelLoadError}})}
var staticRenderFns = []

export { render, staticRenderFns }